import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useEffect } from 'react';

const JRCInputNumber = commonComponentsRegistry.getLazyComponent('InputNumber');

export const EditorInputNumber = ({
    label,
    initialValue,
    handleChange,
}: {
    label: string;
    initialValue?: string;
    handleChange: (value: string) => void;
}) => {
    const intl = useIntl();

    const { control, watch } = useForm({
        defaultValues: { value: initialValue ?? '0' },
        criteriaMode: 'all',
    });

    useEffect(() => {
        const subscription = watch((data) => {
            handleChange(data.value ?? '');
        });
        return () => subscription.unsubscribe();
    }, [watch, handleChange]);

    return (
        <JRCInputNumber
            label={label}
            name={'value'}
            width="100%"
            control={control}
            placeholder={intl.formatMessage({ id: label })}
        />
    );
};
